module.exports = window.UIG_CDN_React_16_8;